import { InjectionToken } from '@angular/core';

import { Address } from './address.interface';
import { Place } from './place.interface';
import { BookableStorageLocation } from './storage-locations';

export interface IGoogleMapsService {
  parsePlaceResult(data: google.maps.places.PlaceResult): Place | null;
  parseGeocoderResult(value: google.maps.GeocoderResult): Place | null;
  parseAddress(
    addressComponents: google.maps.GeocoderAddressComponent[],
    formattedAddress: string,
    lat: number,
    lon: number,
  ): Address;

  parseCity(addressComponents: google.maps.GeocoderAddressComponent[]): string;
  parseRegion(addressComponents: google.maps.GeocoderAddressComponent[]): string;
  getDirectionsLink(storageLocation: BookableStorageLocation): string;
  getDirectionsLink(location: google.maps.LatLng): string;
  getDirectionsLink(locationOrStorageLocation: google.maps.LatLng | BookableStorageLocation): string;
  getPlaceLink(storageLocation: BookableStorageLocation): string | null;
}

export const GOOGLE_MAPS_SERVICE = new InjectionToken<IGoogleMapsService>('GOOGLE_MAPS_SERVICE');
